module.exports = __webpack_public_path__ + "static/media/new-tab-blue.a04e2d8e.svg";